export default "__VITE_ASSET__b2e4b028__"